<div class="flex flex-col md:flex-row min-h-screen bg-white">
  <!-- Sidebar para desktop -->
  <app-sidebar class="bg-teu-purple hidden sm:block relative w-full md:w-[197px] h-[120px] md:h-auto flex-shrink-0 overflow-hidden" [circleNumber]="1" (backClick)="goBack()"></app-sidebar>
  
  <!-- Header para móvil -->
  <app-header [circleNumber]="2" (backClick)="goBack()"></app-header>

  <!-- Contenido principal -->
  <div class="flex-1 flex items-center justify-center bg-gray-50">
    <div class="max-w-md w-full px-8">
      <!-- Logo -->
      <app-subheader [circleNumber]="0" class="pt-[60px] md:pt-0"></app-subheader>

      <!-- Título y descripción -->
      <div class="text-center mb-8">
        <h1 class="text-xl font-semibold text-gray-800 mb-4">
          Se te enviará un código por SMS al
        </h1>
        <p class="text-2xl font-bold text-gray-900 mb-6">5534567123</p>
        <p class="text-gray-600 mb-8">Ingrésalo aquí:</p>
      </div>

      <!-- Campos OTP -->
      <div class="flex justify-center space-x-2">
        <input
          #otpInput
          *ngFor="let _ of otpDigits; let i = index; trackBy: trackByIndex"
          [(ngModel)]="otpDigits[i]"
          (input)="onOtpInput(i)"
          (keydown)="onKeyDown($event, i)"
          (paste)="onPaste($event)"
          class="w-12 h-12 text-center border-2 border-gray-300 rounded-lg text-xl font-semibold focus:border-blue-500 focus:outline-none bg-white"
          maxlength="1"
          type="text"
          autocomplete="one-time-code"
          inputmode="numeric"
        />
      </div>
      <div
        class="flex-row md:text-center sm:text-left space-y-3 space-x-1 py-2 sm:pl-4 sm:pl-9 md:pr-7"
      >
        <span
          class="inline-flex items-center rounded-md px-2 text-xs font-medium text-gray-600 inset-ring inset-ring-gray-500/10"
          style="background-color: #ebebeb"
        >
          <p
            [class]="
              timeRemaining > 0
                ? 'text-sm text-gray-400 mt-2'
                : 'text-sm text-green-600 mt-2 font-medium'
            "
          >
            {{ formattedTime }}
          </p>
        </span>
      </div>

      <!-- Contador y reenvío -->
      <div class="text-center mb-8">
        <p class="text-sm text-gray-500 mb-2">
          Puede tardar hasta 2 minutos en recibir el código.
        </p>
        <p class="text-sm text-gray-500">
          ¿Aún no te llega?
          <button
            (click)="resendCode()"
            [disabled]="!canResend"
            [class]="
              canResend
                ? 'text-blue-500 underline hover:text-blue-600 cursor-pointer'
                : 'text-gray-400 cursor-not-allowed'
            "
          >
            Reenviar por SMS
          </button>
        </p>

        <p *ngIf="canResend" class="text-xs text-green-600 mt-1">
          ¡Ya puedes reenviar el código!
        </p>
      </div>

      <!-- Botón continuar -->
      <button
        (click)="verifyOtp()"
        class="w-full bg-blue-500 text-white py-3 px-6 rounded-lg font-semibold hover:bg-blue-600 transition-colors"
      >
        Continuar
      </button>
    </div>
  </div>
</div>
